// extracted by mini-css-extract-plugin
export var footer = "_mg-5";
export var fulfillmentInput = "_mg-0";
export var shipDateInput = "_mg-1";
export var shipmentModal = "_mg-2";
export var shipmentModalContent = "_mg-3";
export var tableContainer = "_mg-4";